export const VAN_WESTENDORP_QUESTION_ANSWER_TYPE_NUMERIC = 'NUMERIC';

export const VAN_WESTENDORP_QUESTION_SORT_ASCENDING = 'ASC';
export const VAN_WESTENDORP_QUESTION_SORT_DESCENDING = 'DESC';
export const VAN_WESTENDORP_QUESTION_MIN_PRICE = 0;
export const VAN_WESTENDORP_QUESTION_MAX_PRICE = Infinity;
export const VAN_WESTENDORP_QUESTION_DECIMALS = 0;
